import { Button, Modal, Typography } from "@plum-xoxo/admin-dsm";
import React, { useState } from "react";
import { connect } from "react-redux";
import profileService from "../../services/profileService";

const ContactUsModal = ({
  showContactUsModal,
  setShowContactUsModal,
  clientId,
  employeeEmail,
  title,
  cardTitle,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const closeModal = () => {
    setShowContactUsModal(false);
    setIsLoading(false);
  };

  const handleRequestNow = async () => {
    setIsLoading(true);
    try {
      const payload = {
        client_id: clientId,
        email: employeeEmail,
        module: title,
      };

      const response = await profileService.sendPlumGiftingLeadsEmail(payload);

      if (response && response.sendPlumGiftingLeadsEmail) {
        setShowSuccessModal(true);
        setShowContactUsModal(false);
      }
    } catch (error) {
      console.error("Error sending email:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const closeSuccessModal = () => {
    setShowSuccessModal(false);
    closeModal();
  };
  return (
    <div>
      <Modal
        isOpen={showContactUsModal}
        onClose={closeModal}
        disableCloseButton={true}
        style={{ width: "440px" }}
      >
        <Typography.H2 color="dark" shade="c300" className="mb-16">
          Send Us a Request
        </Typography.H2>

        <Typography color="dark" shade="c200" className="mb-24">
          Send us a request and we will get in touch with you to understand your
          requirements and help you send {cardTitle}.
        </Typography>

        <Typography
          component="div"
          className="d-flex justify-content-end w-100 mt-40"
        >
          <Button
            variant="plain"
            onClick={closeModal}
            className="mr-12"
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            variant="fill"
            onClick={handleRequestNow}
            loading={isLoading}
            disabled={isLoading}
          >
            Request Now
          </Button>
        </Typography>
      </Modal>
      <Modal
        isOpen={showSuccessModal}
        onClose={closeSuccessModal}
        disableCloseButton={false}
        style={{ width: "440px" }}
      >
        <div>
          <img
            src="/admin/img/svg-icons/icon-success-large.svg"
            alt="Success"
            style={{ width: "24px" }}
          />
        </div>

        <Typography.H2 color="dark" shade="c300" className="mt-12">
          Request Sent!
        </Typography.H2>

        <Typography color="dark" shade="c200" className="mt-12">
          We will get back to you shortly!
        </Typography>

        <div className="d-flex justify-content-end w-100 mt-28">
          <Button variant="fill" onClick={closeSuccessModal}>
            Done
          </Button>
        </div>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => {
  const {
    accountReducer: {
      clientId = 0,
      employeeDetails: { employee_email = "" } = {},
    } = {},
  } = state;
  return {
    clientId,
    employeeEmail: employee_email,
  };
};

export default connect(mapStateToProps)(ContactUsModal);
